(function () {
  'use strict';

  class ReverbCarousel {
    constructor(sectionId, autoplaySpeed) {
      this.sectionId = sectionId;
      this.track = document.getElementById('reverb-track-' + sectionId);
      this.dotsContainer = document.getElementById('reverb-dots-' + sectionId);
      this.prevBtn = document.querySelector(
        '.reverb-reviews__btn--prev[data-target="' + sectionId + '"]'
      );
      this.nextBtn = document.querySelector(
        '.reverb-reviews__btn--next[data-target="' + sectionId + '"]'
      );

      if (!this.track) return;

      this.cards = Array.from(this.track.querySelectorAll('.reverb-reviews__card'));
      this.totalCards = this.cards.length;
      this.currentIndex = 0;
      this.autoplaySpeed = autoplaySpeed * 1000; // ms
      this.autoplayTimer = null;
      this.visibleCount = this.getVisibleCount();

      this.init();
    }

    getVisibleCount() {
      const w = window.innerWidth;
      if (w <= 600) return 1;
      if (w <= 900) return 2;
      return 3;
    }

    get maxIndex() {
      return Math.max(0, this.totalCards - this.visibleCount);
    }

    init() {
      this.buildDots();
      this.updateTrack();
      this.bindEvents();
      if (this.autoplaySpeed > 0) this.startAutoplay();
    }

    buildDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      const dotCount = this.maxIndex + 1;
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'reverb-reviews__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', (i + 1) + '番目のレビューへ');
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    updateTrack() {
  const cardEl = this.cards[0];
  if (!cardEl) return;

  // トラック全体の幅からgapを考慮して1枚分の幅を計算
  const wrapperWidth = this.track.parentElement.getBoundingClientRect().width;
  const gap = 20;
  const cardWidth = (wrapperWidth - gap * (this.visibleCount - 1)) / this.visibleCount;
  const offset = this.currentIndex * (cardWidth + gap);
  this.track.style.transform = 'translateX(-' + offset + 'px)';

  // ドット更新
  const dots = this.dotsContainer
    ? this.dotsContainer.querySelectorAll('.reverb-reviews__dot')
    : [];
  dots.forEach((d, i) => {
    d.classList.toggle('is-active', i === this.currentIndex);
  });

  // ボタン状態
  if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
  if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
}


    goTo(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateTrack();
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    next() {
      if (this.currentIndex >= this.maxIndex) {
        this.goTo(0); // ループ
      } else {
        this.goTo(this.currentIndex + 1);
      }
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.prev();
      });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.next();
      });

      // タッチスワイプ対応
      let startX = 0;
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          this.stopAutoplay();
          diff > 0 ? this.next() : this.prev();
        }
      }, { passive: true });

      // リサイズ対応
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const newVisible = this.getVisibleCount();
          if (newVisible !== this.visibleCount) {
            this.visibleCount = newVisible;
            this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
            this.buildDots();
            this.updateTrack();
          }
        }, 200);
      });
    }
  }

  // セクションごとに初期化
  function initAll() {
    document.querySelectorAll('.reverb-reviews').forEach((section) => {
      const id = section.id.replace('reverb-reviews-', '');
      const speed = parseInt(section.dataset.autoplay || '5', 10);
      new ReverbCarousel(id, speed);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopifyテーマエディタ対応
  document.addEventListener('shopify:section:load', initAll);
})();
